import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdsApprovalPageRBAC = {
  pageID: 'aa24b44092165773015aba41e32d6eed',
  elementID: {
    ViewOnly: 'e5a4f81edc583e1ecbec6f0897f246be',
  },
} as const

export const useAdsApprovalPageRBAC = createUseRBAC(AdsApprovalPageRBAC.elementID)

export type UseAdsApprovalPageRBACType = ReturnType<typeof useAdsApprovalPageRBAC>
